import { render, staticRenderFns } from "./mLaw.vue?vue&type=template&id=77fe27b8&scoped=true&"
import script from "./mLaw.vue?vue&type=script&lang=js&"
export * from "./mLaw.vue?vue&type=script&lang=js&"
import style0 from "./mLaw.vue?vue&type=style&index=0&id=77fe27b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fe27b8",
  null
  
)

export default component.exports